'use client';

import { cn } from '@ifixit/ui/lib/utils';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import { type ComponentProps } from 'react';

export function Switch({ className, ...props }: ComponentProps<typeof SwitchPrimitive.Root>) {
   return (
      <SwitchPrimitive.Root data-slot="switch" className={cn(className)} {...props}>
         <SwitchPrimitive.Thumb data-slot="switch-thumb" />
      </SwitchPrimitive.Root>
   );
}
